<div #content class="launcher__content" [style.--launcher-height]="launcherHeight()">
  <div class="launcher__header">
    <div class="launcher__header-title">
      {{ 'header.app-launcher' | translate }}
    </div>
    <button type="button" class="launcher__header-close" [attr.aria-label]="'buttons.close' | translate" (click)="closeLauncher.emit()">
      <i aria-hidden="true" class="launcher__header-icon fa-solid fa-grid fa--icon-secondary"></i>
    </button>
  </div>

  @if (loading()) {
    <kds-spinner size="large" variant="absolute" />
  } @else {
    @let modulesValue = modules();

    <div class="launcher__modules">
      @if (modulesValue?.length) {
        <div class="launcher__section">
          @for (module of modulesValue; track module.moduleId; let index = $index; let odd = $odd) {
            <itc-launcher-item [isTooltipRightAligned]="odd" [module]="module" />
          }
        </div>
      } @else {
        <div class="launcher__no-modules">
          <div class="launcher__no-modules-image">
            <itc-themed-image
              lightSrc="assets/icons/empty-states/empty-box-light.svg"
              darkSrc="assets/icons/empty-states/empty-box-dark.svg"
              [width]="140"
              [height]="53"
              [alt]="'launcher.no-modules.alts.no-modules-icon' | translate"
            />
          </div>
          <div class="launcher__no-modules-title">{{ 'launcher.no-modules.title' | translate }}</div>
          <div class="launcher__no-modules-description">
            <span>{{ 'launcher.no-modules.description' | translate }}</span>
            <a class="launcher__no-modules-link" target="_blank" [href]="knowledgeBaseLink">
              {{ 'launcher.no-modules.here' | translate }}
            </a>
            <span>.</span>
          </div>
        </div>
      }
    </div>
  }
</div>
